export const vi = {
  nav: {
    logout: "THOÁT HỆ THỐNG",
    profile: "HỒ SƠ",
    labs: "PHÒNG LAB",
    contact: "LIÊN HỆ",
  },
  home: {
    hero_title: "PHÒNG THÍ NGHIỆM KAI",
    hero_subtext: "Mã nguồn Trí tuệ",
    cta: "XÂM NHẬP DỮ LIỆU LABS",
    featured_title: "KHỐI DỮ LIỆU ĐÃ GIẢI MÃ",
    view_all: "XEM TẤT CẢ GIAO THỨC",
    access_complete: "TRUY CẬP THÀNH CÔNG",
  },
  profile: {
    identity_matrix: "MA TRẬN ĐỊNH DANH",
    agent: "ĐẶC VỤ: KAI",
    status: "TRẠNG THÁI: TRỰC TUYẾN",
    role_label: "VAI TRÒ:",
    role_value: "ĐIỆP VIÊN FULL STACK",
    location_label: "TRẠNG THÁI TÌM VIỆC:",
    location_value: "ĐANG TÌM VIỆC",
    clearance_label: "HẠNG:",
    level: "CẤP",
    xp: "KN",
    personal_attributes: "THUỘC TÍNH CÁ NHÂN",
    physical_attributes: "THUỘC TÍNH VẬT LÝ",
    psychological_attributes: "THUỘC TÍNH TINH THẦN",
    stats: {
      str: "CƠ BẮP", str_desc: "Khả năng tạo lực (Gym/Vận động nặng)",
      vit: "SỨC KHỎE", vit_desc: "Sức khỏe tổng thể (Ảnh hưởng bởi lối sống)",
      agi: "TỐC ĐỘ", agi_desc: "Năng suất làm việc & Tốc độ dự án",
      int: "TRÍ TUỆ (IQ)", int_desc: "Học tập liên tục & Chứng chỉ chuyên môn",
      chr: "CẢM XÚC (EQ)", chr_desc: "Quản lý dự án & Kết nối xã hội",
      sta: "SỨC BỀN (AQ)", sta_desc: "Thâm niên & Nền tảng thể chất",
    },
    base_stats: "Chỉ số cơ bản",
    breakdown: {
      base_stats: "Chỉ số cơ bản",
      max_health_cap: "Giới hạn sức khỏe tối đa",
      certificates_bonus: "Điểm thưởng chứng chỉ",
      projects_bonus: "Điểm thưởng dự án hoàn thành",
      management_bonus: "Điểm thưởng quản lý",
      physical_foundation: "Nền tảng thể chất (STR+VIT)"
    },
    history: {
      kai_labs: "KAI Labs / Tự học",
      gym: "Gym & Thể thao",
      community: "Lãnh đạo cộng đồng Tech",
      lifestyle: "Thức khuya / Overtime"
    },
    actions: {
      add_activity: "HOẠT ĐỘNG NHANH",
      add_experience: "KINH NGHIỆM",
      add_project: "DỰ ÁN",
      add_achievement: "THÀNH TỰU"
    },
    technical_protocols: "GIAO THỨC KỸ THUẬT",
    achievements_title: "THÀNH TỰU",
    validated_achievements: "THÀNH TÍCH ĐÃ XÁC THỰC",
    verified: "ĐÃ XÁC MINH",
    view_coursera: "XEM HỒ SƠ COURSERA",
    github_stats: "KẾT NỐI GITHUB",
    certificates: [
      { 
        name: "Search Engine Optimization (SEO) Specialization", 
        organization: "UC Davis", 
        date: "Nov 6, 2025", 
        link: "https://coursera.org/verify/specialization/zitiktgztqd7u", 
        image: "/certificates/CERTIFICATE_LANDING_PAGE~ZITIKGTZQD7U.jpeg",
        courses_count: "5 Courses",
        description: "Được thiết kế và giảng dạy bởi các chuyên gia hàng đầu. Cung cấp kiến thức và kỹ năng tối ưu hóa website (On-page & Off-page), tìm kiếm từ khóa thông minh, kiểm toán website và phát triển nội dung chất lượng cao."
      },
      { 
        name: "Google Project Management Professional Certificate", 
        organization: "Google", 
        date: "Nov 30, 2025", 
        link: "https://coursera.org/verify/professional-cert/wo217hz8tjep", 
        image: "/certificates/CERTIFICATE_LANDING_PAGE~WO217HZ8TJEP.jpeg",
        courses_count: "7 Courses",
        description: "Hoàn thành 7 khóa học chuyên sâu về quản lý dự án. Có năng lực khởi xướng, lập kế hoạch và điều hành dự án theo cả phương pháp truyền thống và Agile (Linh hoạt)."
      },
      { 
        name: "Generative AI Leader Professional Certificate", 
        organization: "Google Cloud Training", 
        date: "Nov 19, 2025", 
        link: "https://coursera.org/verify/profession-al-cert/enkw129w5m09", 
        image: "/certificates/CERTIFICATE_LANDING_PAGE~ENKW129W5M09.jpeg",
        courses_count: "5 Courses",
        description: "Dành cho lãnh đạo doanh nghiệp trong bối cảnh AI tạo sinh. Khám phá các khái niệm AI/ML, mô hình nền tảng, chiến lược triển khai và AI có trách nhiệm của Google Cloud."
      },
      { 
        name: "HTML, CSS, and Javascript for Web Developers Specialization", 
        organization: "Johns Hopkins University", 
        date: "Nov 22, 2025", 
        link: "https://coursera.org/verify/specialization/zex8jjsgmoe5", 
        image: "/certificates/CERTIFICATE_LANDING_PAGE~ZEX8JJSGMOE5.jpeg",
        courses_count: "4 Courses",
        description: "Nắm vững kiến thức nền tảng về Web Coding: HTML, CSS, Responsive Design và Javascript. Xây dựng ứng dụng web động với chức năng Server-side."
      },
      { 
        name: "Google Prompting Essentials Specialization", 
        organization: "Google", 
        date: "Nov 19, 2025", 
        link: "https://coursera.org/verify/specialization/1282dxyp61a1", 
        image: "/certificates/CERTIFICATE_LANDING_PAGE~1282DXYP61A1.jpeg",
        courses_count: "4 Courses",
        description: "Tập trung xây dựng kỹ năng Prompt AI. Thiết kế prompt hiệu quả và áp dụng kỹ thuật nâng cao để giải quyết nhiệm vụ phức tạp, phân tích dữ liệu và tóm tắt thông tin."
      },
      { 
        name: "Google AI Essentials Specialization", 
        organization: "Google", 
        date: "Sep 30, 2025", 
        link: "https://coursera.org/verify/specialization/2zqo9vs83hxj", 
        image: "/certificates/CERTIFICATE_LANDING_PAGE~2ZQO9VS83HXJ.jpeg",
        courses_count: "5 Courses",
        description: "Hoàn thành 5 khóa học về sử dụng công cụ AI một cách có trách nhiệm và cải thiện năng suất quy trình làm việc."
      },
      { 
        name: "AI Agent Developer Specialization", 
        organization: "Vanderbilt University", 
        date: "Nov 15, 2025", 
        link: "https://coursera.org/verify/specialization/7txh31k0cq84", 
        image: "/certificates/CERTIFICATE_LANDING_PAGE~7TXH31K0CQ84.jpeg",
        courses_count: "6 Courses",
        description: "Chương trình toàn diện về phát triển phần mềm Agentic AI. Thiết kế, xây dựng và triển khai AI Agent sử dụng Python, Prompt Engineering và Generative AI nâng cao."
      }
    ],
  },
  labs: {
    system_tools: "CÔNG CỤ HỆ THỐNG",
    frontend: "FRONT END",
    backend: "BACK END",
    database: "CƠ SỞ DỮ LIỆU",
    system_status: "TRẠNG THÁI HỆ THỐNG",
    uptime: "THỜI GIAN HOẠT ĐỘNG:",
    memory: "BỘ NHỚ:",
    threat_level: "MỨC ĐỘ ĐE DỌA:",
    threat_low: "THẤP",
    title: "PHÒNG THÍ NGHIỆM",
    filters: {
      all: "TẤT CẢ",
      web: "WEB",
      ai: "AI",
      security: "BẢO MẬT",
    }
  },
  contact: {
    title: "BẮT ĐẦU TRUYỀN TIN",
    subtitle: "Kênh bảo mật đã được thiết lập. Nhập thông tin xác thực.",
    name_label: "NHẬP ĐỊNH DANH",
    name_placeholder: "Mật danh hoặc Bí danh",
    email_label: "NHẬP TẦN SỐ",
    email_placeholder: "secure@frequency.com",
    message_label: "NỘI DUNG TRUYỀN TIN",
    message_placeholder: "Nhập gói dữ liệu đã mã hóa...",
    submit_idle: "GỬI BẢO MẬT",
    submit_sending: "ĐANG TRUYỀN...",
    submit_sent: "TRUYỀN TIN HOÀN TẤT",
    access_points: "ĐIỂM TRUY CẬP MÃ HÓA",
    footer_text: "KẾT NỐI BẢO MẬT ĐƯỢC THIẾT LẬP QUA CỔNG 443.\nMÃ HÓA: AES-256-GCM.",
  },
  common: {
    active: "HOẠT ĐỘNG",
    deployed: "ĐÃ TRIỂN KHAI",
    prototype: "NGUYÊN MẪU",
    concept: "Ý TƯỞNG",
    open_project: "OPEN PROJECT",
    private_project: "PRIVATE PROJECT",
  }
};
